export default __webpack_public_path__ + "static/media/new-logo-dark.34b10c93.svg";